<template>
  <div class="main_style">
    <div class="header">
      <div class="header-text">
        <p class="header-title">资产证券化</p>
        <p class="header-desc">
          方案以联盟链为支撑，覆盖资产证券化全流程，包含了资产包管理、资产发行管理、 资产风险管理、现金流管理和资产挂牌管理等主要功能。
        </p>
      </div>
    </div>
    <!-- 产品介绍 -->
    <div class="intro">
      <div class="commom-title">方案介绍</div>
      <div class="intro-content">
        <p>
          方案首先建立了由各参与方共同组成的区块链联盟。在此基础上，在资产证券化全部流程的落地中运用区块链技术，覆盖资产证券化的六个阶段。<br/><br/>在前期的资产池数据、现金流预算结果、风险评级录入阶段，应用区块链技术可以实现更加准确的资产洞察、现金流管理、数据分析和投后管理。到准备期的产品设计发行阶段，交易结构和评级结果由评级公司和券商确认后再共识入链。中期投资人注册登记环节阶段，投资人可以从链上获取数据，以及上传数据至区块链。在存续期管理阶段，回款数据、循环购买数据、资产赎回、置换和回购数据均可入链，并可生成资产服务报告。<br/><br/>方案旨在利用区块链技术穿透底层资产，将底层资产信息上链，保证数据公开、真实、不可篡改，让链上的产品设计全流程透明化，建立新的信任机制，大幅优化交易流程。
        </p>
      </div>
    </div>
    <!-- 产品架构 -->
    <div class="framework">
      <div class="commom-title">方案架构</div>
      <div class="framework-content">
        <img src="https://image.peerfintech.cn/peerfintech_website_v2/solution/assetSecuritization/framework.png" />
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="advantage">
      <div class="commom-title">客户价值</div>
      <div class="advantage-content">
        <el-row :gutter="24">
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img src="@/assets/img/solution/assetSecuritization/role-1.png" />
              </div>
              <div class="title">投资者</div>
              <div class="text">
                通过底层资产逐笔穿透监控，可对资产历史信息、实时表现进行全程监测，缓解了金融资产信息不对称的难题。
              </div>
            </div></el-col
          >
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img src="@/assets/img/solution/assetSecuritization/role-2.png" />
              </div>
              <div class="title">资产发行人</div>
              <div class="text">
                产品设计全流程的透明化，动态实时的信息验证渠道能提升投资者信心，有助于降低操作及合规成本。
              </div>
            </div></el-col
          >
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img src="@/assets/img/solution/assetSecuritization/role-3.png" />
              </div>
              <div class="title">资产管理人</div>
              <div class="text">
                帮助资产管理人从资产生成、筛选组包、资产分析、产品设计、展示上架、投资兑付、资产监控到监管报送在内的全流程智能化管理。
              </div>
            </div></el-col
          >
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    // 页面回退顶部
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="scss" scoped>
.main_style {
  background-color: #ffffff;
  .content-width {
    width: 1200px;
    margin: 0px auto;
  }
  .commom-title {
    padding: 70px 0px 50px;
    font-size: 32px;
    font-family: "PingFangSC-Medium";
    color: rgba(0, 0, 0, 0.85);
    line-height: 45px;
    text-align: center;
  }
  .header {
    width: 100%;
    height: 540px;
    background: url("https://image.peerfintech.cn/peerfintech_website_v2/solution/assetSecuritization/bg.png")
      center/cover no-repeat;
    .header-text {
      @extend .content-width;
      .header-title {
        font-size: 36px;
        font-family: "PingFangSC-Medium";
        color: #000000;
        line-height: 50px;
        padding-top: 160px;
      }
      .header-desc {
        width: 510px;
        color: rgba(0,0,0,0.75);
        font-size: 20px;
        line-height: 33px;
        margin-top: 36px;
      }
    }
  }
  .intro {
    .intro-content {
      @extend .content-width;
      font-size: 18px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 25px;
    }
  }
 
  .framework {
    padding-bottom: 70px;
    .framework-content {
      @extend .content-width;
      img {
        width: 100%;
      }
    }
  }
  .advantage {
    background: #f4f7fc;
    .advantage-content {
      @extend .content-width;
      padding-bottom: 70px;
      .el-row {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .grid-content {
        height: 370px;
        background: #ffffff;
        box-shadow: 3px 3px 15px 0px rgba(0, 0, 0, 0.1);
        padding: 40px 48px 0px 40px;
        .img {
          width: 124px;
          height: 124px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          padding: 24px 0px;
          font-size: 22px;
          font-family: "PingFangSC-Medium";
          color: rgba(0, 0, 0, 0.85);
          line-height: 30px;
        }
        .text {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.45);
          line-height: 22px;
        }
      }
    }
  }
}
</style>
